import { Ionicons } from "@expo/vector-icons";
import React, { useState } from "react";
import { View, Text, Pressable } from "react-native";
import { Menu } from "react-native-paper";

import IndividualAvatar from "@/assets/avatarindividualcard.svg";
import WarningModal from "@/components/modal/utils/WarningModal";

interface CardIndividualProps {
  firstName: string;
  lastName: string;
  individualType: string;
  handleAction: (term: string) => void;
}

export default function CardIndividual(props: CardIndividualProps) {
  const [visible, setVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const handleModalState = (state: boolean) => {
    if (state) {
      props.handleAction("delete");
      setModalVisible(false);
    }
  };

  const handleEdit = () => {
    props.handleAction("edit");
  };

  return (
    <View className="flex-row h-20 w-72 items-center border border-midgray rounded-md m-2 p-4">
      <View>
        <IndividualAvatar width={50} height={50} />
      </View>
      <View className="flex-col flex-grow items-center">
        <Text className="text-base text-black1 font-bold">
          {props.firstName} {props.lastName}
        </Text>
        <Text className="text-sm text-black1">
          {props.individualType.replace("_", " ")}
        </Text>
      </View>
      <Menu
        visible={visible}
        onDismiss={() => setVisible(false)}
        contentStyle={{ backgroundColor: "white", borderRadius: 16 }}
        anchor={
          <Pressable onPress={() => setVisible(true)}>
            <Ionicons name="ellipsis-vertical" size={20} />
          </Pressable>
        }
      >
        <Menu.Item
          title="Edit"
          style={{ flexDirection: "row", alignItems: "center" }}
          titleStyle={{ color: "black", fontSize: 14 }}
          onPress={() => {
            handleEdit();
          }}
        />
        <Menu.Item
          title="Delete"
          style={{ flexDirection: "row", alignItems: "center" }}
          titleStyle={{ color: "black", fontSize: 14 }}
          onPress={() => {
            setModalVisible(true);
          }}
        />
      </Menu>
      <WarningModal
        text={props.firstName + " " + props.lastName + " will be deleted."}
        visible={modalVisible}
        onClick={(state) => handleModalState(state)}
        onClose={() => setModalVisible(false)}
      />
    </View>
  );
}
